import CaptainProactiveTriggersAPI from 'dashboard/api/captain/proactiveTriggers';

const state = {
  records: [],
  uiFlags: {
    fetching: false,
    saving: false,
    deleting: false,
  },
};

const getters = {
  getRecords: s => s.records,
  getUIFlags: s => s.uiFlags,
};

const mutations = {
  SET_RECORDS(s, records) {
    s.records = records;
  },
  ADD_RECORD(s, record) {
    s.records = [...s.records, record];
  },
  UPDATE_RECORD(s, updated) {
    const idx = s.records.findIndex(r => r.id === updated.id);
    if (idx !== -1) {
      s.records = [
        ...s.records.slice(0, idx),
        updated,
        ...s.records.slice(idx + 1),
      ];
    }
  },
  REMOVE_RECORD(s, id) {
    s.records = s.records.filter(r => r.id !== id);
  },
  SET_UI_FLAG(s, flags) {
    s.uiFlags = { ...s.uiFlags, ...flags };
  },
};

const actions = {
  fetch: async ({ commit }) => {
    commit('SET_UI_FLAG', { fetching: true });
    try {
      const response = await CaptainProactiveTriggersAPI.get();
      commit('SET_RECORDS', response.data);
    } finally {
      commit('SET_UI_FLAG', { fetching: false });
    }
  },

  create: async ({ commit }, data) => {
    commit('SET_UI_FLAG', { saving: true });
    try {
      const response = await CaptainProactiveTriggersAPI.create(data);
      commit('ADD_RECORD', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { saving: false });
    }
  },

  update: async ({ commit }, { id, ...data }) => {
    commit('SET_UI_FLAG', { saving: true });
    try {
      const response = await CaptainProactiveTriggersAPI.update(id, data);
      commit('UPDATE_RECORD', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { saving: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit('SET_UI_FLAG', { deleting: true });
    try {
      await CaptainProactiveTriggersAPI.delete(id);
      commit('REMOVE_RECORD', id);
    } finally {
      commit('SET_UI_FLAG', { deleting: false });
    }
  },

  toggle: async ({ commit }, id) => {
    const response = await CaptainProactiveTriggersAPI.toggle(id);
    commit('UPDATE_RECORD', response.data);
    return response.data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
